
import { defineComponent } from 'vue'

const NotFound = defineComponent({})

export default NotFound
